module.exports = __webpack_public_path__ + "img/FotoMo10.a29fdead.png";